/**
 * Builds the HTML for the pagination bar.
 * Generates page numbers, active state, and spacer dots when page gaps exist.
 * @param {Object} params
 * @param {number[]} params.pages - List of page numbers to render.
 * @param {number} params.currentPage - Currently active page.
 * @param {Function} params.buildPageUrl - Function that builds a URL for a given page.
 * @returns {string} HTML string representing the pagination bar.
 */
export default function paginationBar({
  pages,
  currentPage,
  buildPageUrl
}) {
  return pages.reduce((accumulator, pageNumber, pageIndex) => {
    const previousPageNumber = pages[pageIndex - 1] || 0;
    const threeDotsElement = previousPageNumber + 1 !== pageNumber
      ? `<li class="nhs-c-pagination__spacer-container nhs-mq-pagination__spacer-container--extra-large"><span>...</span></li>` 
      : '';

    const currentPageClasses = pageNumber === currentPage ? "nhs-c-pagination__number--active" : '';

    const pageLink =
      `<li class="nhs-c-pagination__number-container nhs-mq-pagination__number-container--extra-large" data-qa="pagination_number_container">
        <a data-page-link="${pageNumber}" href="${buildPageUrl(pageNumber)}" aria-label="Go to ${pageNumber} page" class="nhs-c-pagination__number nhs-mq-pagination__number--extra-large ${currentPageClasses}">${pageNumber}</a>
      </li>`;

    return `${accumulator}${threeDotsElement}${pageLink}`;
}, '');
}